
// // client/src/components/Integrations.jsx
// // FIXED: Prevents infinite re-render loop with proper error handling
// // UPDATED: Improved UI with aligned buttons, username display, and consistent sizing

// import React, { useEffect, useState, useRef } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import AppFooter from './AppFooter';
// import { FaTimes, FaArrowLeft, FaHome, FaCheck } from 'react-icons/fa';
// import { ensureFbSdk } from '../utils/ensureFbSdk';
// import YouTubeConnectButton from './YouTubeConnectButton';
// import TikTokConnectButton from './TikTokConnectButton';
// import TikTokMetrics from './TikTokMetrics';
// import globalErrorHandler from '../utils/globalErrorHandler';

// const FB_APP_ID = '748347668239935';
// const FB_VERSION = 'v24.0';

// function Integrations() {
//   const [statusMessage, setStatusMessage] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [fbStatus, setFbStatus] = useState(null);
//   const [showTikTokMetrics, setShowTikTokMetrics] = useState(false);
//   const [twitterTokenStatus, setTwitterTokenStatus] = useState(null);
//   const [checkingTwitterStatus, setCheckingTwitterStatus] = useState(false);
  
//   // Connection status for all platforms
//   const [connectionStatus, setConnectionStatus] = useState({});
//   const [loadingStatus, setLoadingStatus] = useState(true);
//   const [statusError, setStatusError] = useState(null); // NEW: Track errors
  
//   // Prevent infinite loops
//   const isFetchingRef = useRef(false); // NEW: Prevent concurrent fetches
//   const fetchAttemptRef = useRef(0); // NEW: Track fetch attempts

//   const navigate = useNavigate();
//   const { tenant } = useParams();
//   const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin || 'http://localhost:5000';

//   const getTenantId = () =>
//     Number(tenant) || Number(localStorage.getItem('tenantId')) || 1;

//   const handleDashboard = () => navigate(`/${getTenantId()}/dashboard`);

//   // FIXED: Fetch connection status with proper error handling and retry limits
//   const fetchConnectionStatus = async () => {
//     // Prevent concurrent fetches
//     if (isFetchingRef.current) {
//       console.log('[Integrations] Fetch already in progress, skipping...');
//       return;
//     }
    
//     // Limit retry attempts
//     if (fetchAttemptRef.current >= 3) {
//       console.error('[Integrations] Max fetch attempts reached, stopping...');
//       setStatusError('Failed to load connection status after 3 attempts');
//       setLoadingStatus(false);
//       return;
//     }
    
//     isFetchingRef.current = true;
//     fetchAttemptRef.current += 1;
    
//     try {
//       setLoadingStatus(true);
//       setStatusError(null);
      
//       const tenantId = getTenantId();
//       console.log('[Integrations] Fetching status for tenant:', tenantId);
      
//       const controller = new AbortController();
//       const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
//       const response = await fetch(
//         `${baseUrl}/api/integrations/status/${tenantId}`,
//         { 
//           signal: controller.signal,
//           headers: { 'Content-Type': 'application/json' }
//         }
//       );
      
//       clearTimeout(timeoutId);
      
//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }
      
//       const data = await response.json();
      
//       if (data.success) {
//         setConnectionStatus(data.integrations || {});
//         setStatusError(null);
//         fetchAttemptRef.current = 0; // Reset on success
//         console.log('[Integrations] Status loaded successfully');
//       } else {
//         throw new Error(data.message || 'Failed to fetch status');
//       }
//     } catch (error) {
//       if (error.name === 'AbortError') {
//         console.error('[Integrations] Fetch timeout after 10 seconds');
//         setStatusError('Connection timeout - server may be slow');
//       } else {
//         console.error('[Integrations] Failed to fetch connection status:', error);
//         setStatusError('Failed to load connection status');
//       }
      
//       // Set empty status on error to prevent infinite loops
//       setConnectionStatus({});
      
//       globalErrorHandler.logError(error, { 
//         component: 'Integrations - Fetch Status',
//         attempt: fetchAttemptRef.current
//       });
//     } finally {
//       isFetchingRef.current = false;
//       setLoadingStatus(false);
//     }
//   };

//   // Disconnect a specific platform
//   const handleDisconnect = async (provider) => {
//     if (!window.confirm(`Are you sure you want to disconnect ${provider}?`)) {
//       return;
//     }

//     try {
//       const tenantId = getTenantId();
//       const response = await fetch(
//         `${baseUrl}/api/integrations/disconnect/${tenantId}/${provider}`,
//         { method: 'DELETE' }
//       );
      
//       const data = await response.json();
      
//       if (data.success) {
//         setStatusMessage(`✅ ${provider} disconnected successfully`);
//         // Reset fetch attempts and refresh
//         fetchAttemptRef.current = 0;
//         await fetchConnectionStatus();
//       } else {
//         setStatusMessage(`❌ Failed to disconnect ${provider}: ${data.message}`);
//       }
//     } catch (error) {
//       console.error(`Failed to disconnect ${provider}:`, error);
//       setStatusMessage(`❌ Error disconnecting ${provider}`);
//       globalErrorHandler.logError(error, { component: 'Integrations - Disconnect', provider });
//     }
//   };

//   // Initialize Facebook SDK
//   useEffect(() => {
//     (async () => {
//       try {
//         const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);
//         FB.getLoginStatus((response) => setFbStatus(response));
//       } catch (err) {
//         console.error('Failed to init FB SDK', err);
//         globalErrorHandler.logError(err, { component: 'Integrations - FB SDK Init' });
//       }
//     })();
//   }, []);

//   // Fetch connection status on mount - ONLY ONCE
//   useEffect(() => {
//     fetchConnectionStatus();
//     checkTwitterTokenStatus();
//   }, []); // Empty dependency array - runs only once on mount

//   // Check for success messages in URL (after OAuth redirects)
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
    
//     if (urlParams.get('twitter_posting_granted') === 'true') {
//       setStatusMessage('✅ Twitter posting permissions granted successfully!');
//       checkTwitterTokenStatus();
//       // Reset fetch attempts and refresh
//       fetchAttemptRef.current = 0;
//       fetchConnectionStatus();
      
//       // Clean up URL
//       window.history.replaceState({}, document.title, window.location.pathname);
//     }
//   }, []);

//   // Check Twitter OAuth token status
//   const checkTwitterTokenStatus = async () => {
//     try {
//       setCheckingTwitterStatus(true);
//       const tenantId = getTenantId();
//       const response = await fetch(`${baseUrl}/api/integrations/twitter/oauth1a/status/${tenantId}`);
//       const data = await response.json();
      
//       setTwitterTokenStatus(data);
//       console.log('[Twitter] Token status:', data);
//     } catch (error) {
//       console.error('Failed to check Twitter token status:', error);
//     } finally {
//       setCheckingTwitterStatus(false);
//     }
//   };

//   const grantTwitterPostingPermissions = () => {
//     try {
//       setLoading(true);
//       setStatusMessage('Redirecting to Twitter for posting permissions...');
      
//       const tenantId = getTenantId();
//       const authUrl = `${baseUrl}/api/integrations/twitter/oauth1a/initiate/${tenantId}`;
      
//       console.log('[Twitter OAuth 1.0a] Initiating posting permissions flow:', authUrl);
      
//       window.location.href = authUrl;
      
//     } catch (err) {
//       console.error('❌ Failed to initiate Twitter posting permissions:', err);
//       setStatusMessage(`❌ ${err.message || 'Error initiating posting permissions'}`);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const handleTwitterCallback = (event) => {
//       if (event.origin !== window.location.origin && event.origin !== baseUrl.replace(/\/$/, '')) {
//         return;
//       }

//       if (event.data?.type === 'TWITTER_OK') {
//         setStatusMessage('✅ Twitter connected successfully');
//         setLoading(false);
//         console.log('[Twitter] Connection successful');
//         checkTwitterTokenStatus();
//         fetchAttemptRef.current = 0;
//         fetchConnectionStatus();
//       } else if (event.data?.type === 'TWITTER_ERR') {
//         const msg = event.data.error || 'Twitter authorization failed';
//         setStatusMessage(`❌ ${msg}`);
//         setLoading(false);
//         console.error('[Twitter] Connection error:', event.data);
//         globalErrorHandler.logError(
//           new Error(msg),
//           { 
//             component: 'Twitter OAuth',
//             errorData: event.data
//           }
//         );
//       }
//     };

//     window.addEventListener('message', handleTwitterCallback);
//     return () => window.removeEventListener('message', handleTwitterCallback);
//   }, [baseUrl]);

//   const connectToTwitter = async () => {
//     try {
//       setLoading(true);
//       setStatusMessage('Connecting to Twitter...');
      
//       const tenantId = getTenantId();
//       const authUrl = `${baseUrl}/api/integrations/twitter/connect/${tenantId}`;
      
//       console.log('[Twitter OAuth 2.0] Opening popup for:', authUrl);
      
//       const w = window.open(
//         authUrl,
//         'twitter_oauth',
//         'width=600,height=700,menubar=no,toolbar=no,status=no'
//       );
//       if (!w) {
//         setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
//         setLoading(false);
//         return;
//       }
//       w.focus?.();
//     } catch (err) {
//       console.error('❌ Failed to open Twitter popup:', err);
//       setStatusMessage(`❌ ${err.message || 'Failed to connect to Twitter'}`);
//       setLoading(false);
//       globalErrorHandler.logError(err, { component: 'Twitter Connect' });
//     }
//   };

//   const connectToTikTok = () => {
//     const meTenant = getTenantId();
//     const url = `${baseUrl}/api/integrations/tiktok/login?tenantId=${encodeURIComponent(meTenant)}`;
//     const w = window.open(
//       url,
//       'tiktok_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
//     if (!w) {
//       setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
//       if (ev.data.type === 'TIKTOK_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ TikTok connected');
//         fetchAttemptRef.current = 0;
//         fetchConnectionStatus();
//       } else if (ev.data.type === 'TIKTOK_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error_message || ev.data.error || 'TikTok login failed';
//         setStatusMessage(`❌ ${msg}`);
//         console.error('TIKTOK_ERR from popup:', ev.data);
//       }
//     };
//     window.addEventListener('message', onMsg);
//   };

//   async function peekEligibility(tenantId) {
//     try {
//       const peekRes = await fetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
//       const peek = await peekRes.json();
//       const pageCount = Array.isArray(peek?.pages) ? peek.pages.length : 0;

//       setStatusMessage(
//         pageCount > 0
//           ? '✅ Facebook/Instagram connected'
//           : 'Connected to Facebook. Ensure your IG is Business/Creator, linked to a Page, and you have Full control.'
//       );
      
//       fetchAttemptRef.current = 0;
//       fetchConnectionStatus();
//     } catch (e) {
//       console.error('peek error', e);
//       setStatusMessage('Connected, but could not verify eligibility. Check console.');
//       globalErrorHandler.logError(e, { component: 'Facebook Peek' });
//     }
//   }

//   const connectViaSdk = async () => {
//     try {
//       const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);

//       if (!FB || typeof FB.login !== 'function') {
//         throw new Error('Facebook SDK not ready');
//       }

//       setLoading(true);
//       setStatusMessage('Opening Facebook login...');

//       FB.login(
//         (response) => {
//           setLoading(false);

//           if (!response?.authResponse) {
//             setStatusMessage('❌ Login cancelled or failed');
//             console.warn('FB login: no authResponse', response);
//             return;
//           }

//           const { userID, accessToken } = response.authResponse;
//           console.log('✅ FB login success. userID:', userID, 'accessToken:', accessToken);

//           setStatusMessage('Connected to Facebook. Fetching eligible Pages...');

//           FB.api(
//             '/me/accounts',
//             { fields: 'id,name,access_token,instagram_business_account' },
//             async (apiResp) => {
//               console.log('/me/accounts response:', apiResp);

//               if (apiResp.error) {
//                 setStatusMessage(`❌ FB API error: ${apiResp.error.message}`);
//                 console.error('FB API error', apiResp.error);
//                 return;
//               }

//               const pages = (apiResp.data || [])
//                 .map((p) => ({
//                   pageId: p.id,
//                   pageName: p.name,
//                   pageToken: p.access_token,
//                   igUserId: p.instagram_business_account?.id || null,
//                 }))
//                 .filter((p) => p.pageToken);

//               console.log('Extracted pages with IG:', pages);

//               if (pages.length === 0) {
//                 setStatusMessage(
//                   '❌ No eligible Pages found with full control. Check your FB permissions.'
//                 );
//                 return;
//               }

//               const savePayload = {
//                 userToken: accessToken,
//                 userId: userID,
//                 pageInfos: pages,
//                 savedAt: new Date().toISOString(),
//               };

//               try {
//                 const tenantId = getTenantId();
                
//                 const saveResp = await fetch(`${baseUrl}/api/integrations/facebook/token-login`, {
//                   method: 'POST',
//                   headers: { 'Content-Type': 'application/json' },
//                   body: JSON.stringify({ tenantId, accessToken }),
//                 });

//                 const saveData = await saveResp.json();
//                 if (saveData.success) {
//                   await peekEligibility(tenantId);
                  
//                   try {
//                     console.log('[Instagram] Syncing username...');
//                     const syncResponse = await fetch(
//                       `${baseUrl}/api/integrations/instagram/sync-username/${tenantId}`,
//                       { method: 'POST' }
//                     );
//                     const syncData = await syncResponse.json();
                    
//                     if (syncData.success) {
//                       console.log('✅ Instagram username synced:', syncData.username);
//                     } else {
//                       console.warn('⚠️ Instagram username sync failed:', syncData.message);
//                     }
//                   } catch (syncErr) {
//                     console.error('Instagram username sync error:', syncErr);
//                   }
                  
//                   fetchAttemptRef.current = 0;
//                   await fetchConnectionStatus();
                  
//                 } else {
//                   setStatusMessage(`❌ Save failed: ${saveData.message}`);
//                 }
//               } catch (err) {
//                 console.error('Save error', err);
//                 setStatusMessage('❌ Failed to save FB credentials');
//                 globalErrorHandler.logError(err, { component: 'Facebook Save' });
//               }
//             }
//           );
//         },
//         {
//           scope: 'pages_show_list,pages_read_engagement,pages_manage_posts,instagram_basic,instagram_content_publish',
//           return_scopes: true,
//         }
//       );
//     } catch (err) {
//       setLoading(false);
//       const msg = err?.message || 'Unknown error initializing Facebook SDK';
//       setStatusMessage(`❌ ${msg}`);
//       console.error('connectViaSdk error:', err);
//       globalErrorHandler.logError(err, { component: 'Facebook Connect' });
//     }
//   };

//   const connectLinkedIn = () => {
//     const meTenant = getTenantId();
//     const url = `${baseUrl}/api/integrations/linkedin/login?tenantId=${encodeURIComponent(meTenant)}`;
//     const w = window.open(
//       url,
//       'li_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
    
//     if (!w) {
//       setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
    
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
      
//       if (ev.data.type === 'LI_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ LinkedIn connected');
//         console.log('[LinkedIn] Connection successful for tenant:', ev.data.tenantId);
//         fetchAttemptRef.current = 0;
//         fetchConnectionStatus();
//       } else if (ev.data.type === 'LI_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error_description || ev.data.error || 'LinkedIn login failed';
//         setStatusMessage(`❌ LinkedIn: ${msg}`);
//         console.error('[LinkedIn] Connection error:', ev.data);
//       }
//     };
    
//     window.addEventListener('message', onMsg);
//   };

//   const connectBluesky = () => {
//     const meTenant = getTenantId();
//     const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${encodeURIComponent(meTenant)}`;
//     const w = window.open(
//       url,
//       'bsky_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
//     if (!w) {
//       setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
//       if (ev.data.type === 'BSKY_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ Bluesky connected');
//         fetchAttemptRef.current = 0;
//         fetchConnectionStatus();
//       } else if (ev.data.type === 'BSKY_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error_message || ev.data.error || 'Bluesky login failed';
//         setStatusMessage(`❌ ${msg}`);
//         console.error('BSKY_ERR from popup:', ev.data);
//       }
//     };
//     window.addEventListener('message', onMsg);
//   };

//   const connectThreads = () => {
//     const meTenant = getTenantId();
//     const url = `${baseUrl}/api/integrations/threads/login?tenantId=${encodeURIComponent(meTenant)}`;
//     const w = window.open(
//       url,
//       'threads_oauth',
//       'width=700,height=800,menubar=no,toolbar=no,status=no'
//     );
//     if (!w) {
//       setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
//       return;
//     }
//     w.focus?.();

//     const onMsg = (ev) => {
//       if (!ev?.data) return;
//       if (ev.data.type === 'THREADS_OK') {
//         window.removeEventListener('message', onMsg);
//         setStatusMessage('✅ Threads connected');
//         fetchAttemptRef.current = 0;
//         fetchConnectionStatus();
//       } else if (ev.data.type === 'THREADS_ERR') {
//         window.removeEventListener('message', onMsg);
//         const msg = ev.data.error || 'Threads login failed';
//         setStatusMessage(`❌ ${msg}`);
//         console.error('THREADS_ERR from popup:', ev.data);
//       }
//     };
//     window.addEventListener('message', onMsg);
//   };

//   const handleTikTokConnectionChange = (isConnected) => {
//     setShowTikTokMetrics(isConnected);
//     fetchAttemptRef.current = 0;
//     fetchConnectionStatus();
//   };

//   /**
//    * UPDATED: Render integration button with improved layout
//    * - Platform name centered at top
//    * - Username centered below platform name in green (matching success message)
//    * - All buttons same width with username truncation
//    * - Delete button aligned to row, same height and width
//    */
//   const renderIntegrationButton = (provider, label, onClick) => {
//     const status = connectionStatus[provider];
//     const isConnected = status?.connected || false;
//     const accountNameRaw = (status?.accountName || '').trim();
//     const accountName = accountNameRaw
//       ? (accountNameRaw.startsWith('@') ? accountNameRaw : `@${accountNameRaw}`)
//       : '';

//     return (
//       <div className="integration-row">
//         <button
//           type="button"
//           className="btn btn-primary integration-btn"
//           onClick={onClick}
//           disabled={loading}
//         >
//           <span className="integration-btn-content">
//             {/* Platform label - centered at top */}
//             <span className="integration-btn-label">{label.toUpperCase()}</span>

//             {/* Username - centered below platform name in green */}
//             {isConnected && accountName && (
//               <span
//                 className="integration-btn-username"
//                 title={accountName}
//               >
//                 {accountName}
//               </span>
//             )}
            
//             {/* Checkmark - positioned absolutely in top right */}
//             {isConnected && (
//               <FaCheck className="integration-check" aria-label="Connected" />
//             )}
//           </span>
//         </button>

//         {/* Delete button - same height, aligned to row */}
//         {isConnected ? (
//           <button
//             type="button"
//             className="integration-delete-btn"
//             onClick={(e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               handleDisconnect(provider);
//             }}
//             title={`Disconnect ${label}`}
//             aria-label={`Disconnect ${label}`}
//           >
//             <FaTimes />
//           </button>
//         ) : (
//           <span className="integration-delete-spacer" aria-hidden="true" />
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="owner-add-container">
//       <div className="card">
//         <h4 className="hdr hdr--primary hdr--lg">Integrations</h4>
//         <div className="card-body">
//           {loadingStatus && !statusError ? (
//             <p>Loading connection status...</p>
//           ) : statusError ? (
//             <div style={{ padding: '20px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '5px', marginBottom: '20px' }}>
//               <p style={{ margin: 0, color: '#856404' }}>
//                 ⚠️ {statusError}
//               </p>
//               <button 
//                 onClick={() => {
//                   fetchAttemptRef.current = 0;
//                   fetchConnectionStatus();
//                 }}
//                 style={{ marginTop: '10px', padding: '5px 15px', cursor: 'pointer' }}
//               >
//                 Retry
//               </button>
//             </div>
//           ) : (
//             <form className="form integrations-form">

//               {renderIntegrationButton('instagram', 'Instagram', connectViaSdk)}
//               {renderIntegrationButton('facebook', 'Facebook', connectViaSdk)}
//               {renderIntegrationButton('twitter', 'Twitter', connectToTwitter)}
//               {renderIntegrationButton('tiktok', 'TikTok', connectToTikTok)}

//               {/* Twitter posting permissions warning */}
//               {twitterTokenStatus?.connected && twitterTokenStatus?.needsPosting && (
//                 <div style={{ 
//                   marginTop: '15px',
//                   marginBottom: '15px',
//                   padding: '15px', 
//                   backgroundColor: '#fff3cd', 
//                   border: '2px solid #ffc107',
//                   borderRadius: '8px'
//                 }}>
//                   <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
//                     <span style={{ fontSize: '24px' }}>⚠️</span>
//                     <div style={{ flex: 1 }}>
//                       <h4 style={{ 
//                         margin: '0 0 8px 0', 
//                         color: '#856404',
//                         fontSize: '16px',
//                         fontWeight: '600'
//                       }}>
//                         Twitter Posting Permissions Required
//                       </h4>
//                       <p style={{ 
//                         margin: '0 0 12px 0', 
//                         fontSize: '14px', 
//                         color: '#856404',
//                         lineHeight: '1.5'
//                       }}>
//                         Your Twitter account is connected, but you need to grant additional permissions to enable post scheduling and media uploads.
//                       </p>
//                       <button
//                         type="button"
//                         onClick={grantTwitterPostingPermissions}
//                         disabled={loading}
//                         style={{
//                           backgroundColor: '#ff6800',
//                           color: 'white',
//                           padding: '10px 20px',
//                           border: 'none',
//                           borderRadius: '5px',
//                           cursor: loading ? 'not-allowed' : 'pointer',
//                           fontSize: '14px',
//                           fontWeight: '600',
//                           boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//                           transition: 'all 0.2s'
//                         }}
//                         onMouseOver={(e) => {
//                           if (!loading) {
//                             e.target.style.backgroundColor = '#e55d00';
//                             e.target.style.transform = 'translateY(-1px)';
//                             e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
//                           }
//                         }}
//                         onMouseOut={(e) => {
//                           e.target.style.backgroundColor = '#ff6800';
//                           e.target.style.transform = 'translateY(0)';
//                           e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
//                         }}
//                       >
//                         {loading ? 'Redirecting...' : 'Grant Posting Permissions'}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {renderIntegrationButton('threads', 'Threads', connectThreads)}
//               {renderIntegrationButton('linkedin', 'LinkedIn', connectLinkedIn)}
//               {renderIntegrationButton('bluesky', 'Bluesky', connectBluesky)}

//               {/* Status message with matching style */}
//               {statusMessage && (
//                 <p className="integrations-status-message">{statusMessage}</p>
//               )}
//             </form>
//           )}
//         </div>
//       </div>

//       {showTikTokMetrics && (
//         <div className="mt-4">
//           <TikTokMetrics tenantId={getTenantId()} />
//         </div>
//       )}

//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: "Back",
//             onClick: () => navigate(-1),
//           },
//           { icon: <FaHome />, label: 'Home', onClick: handleDashboard }
//         ]}
//       />
//     </div>
//   );
// }

// export default Integrations;


// client/src/components/Integrations.jsx
// FIXED: Prevents infinite re-render loop with proper error handling
// UPDATED: All platforms use standardized renderIntegrationButton for consistent UI/UX
// ADDED: YouTube integration with OAuth popup flow matching other platforms

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppFooter from './AppFooter';
import { FaTimes, FaArrowLeft, FaHome, FaCheck, FaEnvelope } from 'react-icons/fa';
import { ensureFbSdk } from '../utils/ensureFbSdk';
import TikTokMetrics from './TikTokMetrics';
import globalErrorHandler from '../utils/globalErrorHandler';
import PasswordInput from './shared/PasswordInput';

const FB_APP_ID = '748347668239935';
const FB_VERSION = 'v24.0';

function Integrations() {
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [, setFbStatus] = useState(null);
  const [showTikTokMetrics] = useState(false);
  const [twitterTokenStatus, setTwitterTokenStatus] = useState(null);
  const [, setCheckingTwitterStatus] = useState(false);
  
  // Connection status for all platforms
  const [connectionStatus, setConnectionStatus] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(true);
  const [statusError, setStatusError] = useState(null); // NEW: Track errors
  
  // Email SMTP integration
  const [showEmailConfig, setShowEmailConfig] = useState(false);
  const [emailConfig, setEmailConfig] = useState({ host: '', port: '587', user: '', pass: '', from_address: '', secure: false });
  const [emailConfigured, setEmailConfigured] = useState(false);
  const [emailPassMasked, setEmailPassMasked] = useState('');
  const [emailTesting, setEmailTesting] = useState(false);
  const [emailSaving, setEmailSaving] = useState(false);
  const [emailMessage, setEmailMessage] = useState('');

  // Prevent infinite loops
  const isFetchingRef = useRef(false); // NEW: Prevent concurrent fetches
  const fetchAttemptRef = useRef(0); // NEW: Track fetch attempts

  const navigate = useNavigate();
  const { tenant } = useParams();
  const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin || 'http://localhost:5000';

  const getTenantId = () =>
    Number(tenant) || Number(localStorage.getItem('tenantId')) || 1;

  const handleDashboard = () => navigate(`/${getTenantId()}/dashboard`);

  // FIXED: Fetch connection status with proper error handling and retry limits
  const fetchConnectionStatus = async () => {
    // Prevent concurrent fetches
    if (isFetchingRef.current) {
      console.log('[Integrations] Fetch already in progress, skipping...');
      return;
    }
    
    // Limit retry attempts
    if (fetchAttemptRef.current >= 3) {
      console.error('[Integrations] Max fetch attempts reached, stopping...');
      setStatusError('Failed to load connection status after 3 attempts');
      setLoadingStatus(false);
      return;
    }
    
    isFetchingRef.current = true;
    fetchAttemptRef.current += 1;
    
    try {
      setLoadingStatus(true);
      setStatusError(null);
      
      const tenantId = getTenantId();
      console.log('[Integrations] Fetching status for tenant:', tenantId);
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(
        `${baseUrl}/api/integrations/status/${tenantId}`,
        { 
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json' }
        }
      );
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        setConnectionStatus(data.integrations || {});
        setStatusError(null);
        fetchAttemptRef.current = 0; // Reset on success
        console.log('[Integrations] Status loaded successfully');
      } else {
        throw new Error(data.message || 'Failed to fetch status');
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('[Integrations] Fetch timeout after 10 seconds');
        setStatusError('Connection timeout - server may be slow');
      } else {
        console.error('[Integrations] Failed to fetch connection status:', error);
        setStatusError('Failed to load connection status');
      }
      
      // Set empty status on error to prevent infinite loops
      setConnectionStatus({});
      
      globalErrorHandler.logError(error, { 
        component: 'Integrations - Fetch Status',
        attempt: fetchAttemptRef.current
      });
    } finally {
      isFetchingRef.current = false;
      setLoadingStatus(false);
    }
  };

  // Disconnect a specific platform
  const handleDisconnect = async (provider) => {
    if (!window.confirm(`Are you sure you want to disconnect ${provider}?`)) {
      return;
    }

    try {
      const tenantId = getTenantId();
      const response = await fetch(
        `${baseUrl}/api/integrations/disconnect/${tenantId}/${provider}`,
        { method: 'DELETE' }
      );
      
      const data = await response.json();
      
      if (data.success) {
        setStatusMessage(`✅ ${provider} disconnected successfully`);
        // Reset fetch attempts and refresh
        fetchAttemptRef.current = 0;
        await fetchConnectionStatus();
      } else {
        setStatusMessage(`❌ Failed to disconnect ${provider}: ${data.message}`);
      }
    } catch (error) {
      console.error(`Failed to disconnect ${provider}:`, error);
      setStatusMessage(`❌ Error disconnecting ${provider}`);
      globalErrorHandler.logError(error, { component: 'Integrations - Disconnect', provider });
    }
  };

  // Initialize Facebook SDK
  useEffect(() => {
    (async () => {
      try {
        const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);
        FB.getLoginStatus((response) => setFbStatus(response));
      } catch (err) {
        console.error('Failed to init FB SDK', err);
        globalErrorHandler.logError(err, { component: 'Integrations - FB SDK Init' });
      }
    })();
  }, []);

  // Fetch connection status on mount - ONLY ONCE
  useEffect(() => {
    fetchConnectionStatus();
    checkTwitterTokenStatus();
    fetchEmailConfig();
  }, []); // Empty dependency array - runs only once on mount

  // Check for success messages in URL (after OAuth redirects)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.get('twitter_posting_granted') === 'true') {
      setStatusMessage('✅ Twitter posting permissions granted successfully!');
      checkTwitterTokenStatus();
      // Reset fetch attempts and refresh
      fetchAttemptRef.current = 0;
      fetchConnectionStatus();
      
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // Check Twitter OAuth token status
  const checkTwitterTokenStatus = async () => {
    try {
      setCheckingTwitterStatus(true);
      const tenantId = getTenantId();
      const response = await fetch(`${baseUrl}/api/integrations/twitter/oauth1a/status/${tenantId}`);
      const data = await response.json();
      
      setTwitterTokenStatus(data);
      console.log('[Twitter] Token status:', data);
    } catch (error) {
      console.error('Failed to check Twitter token status:', error);
    } finally {
      setCheckingTwitterStatus(false);
    }
  };

  const grantTwitterPostingPermissions = () => {
    try {
      setLoading(true);
      setStatusMessage('Redirecting to Twitter for posting permissions...');
      
      const tenantId = getTenantId();
      const authUrl = `${baseUrl}/api/integrations/twitter/oauth1a/initiate/${tenantId}`;
      
      console.log('[Twitter OAuth 1.0a] Initiating posting permissions flow:', authUrl);
      
      window.location.href = authUrl;
      
    } catch (err) {
      console.error('❌ Failed to initiate Twitter posting permissions:', err);
      setStatusMessage(`❌ ${err.message || 'Error initiating posting permissions'}`);
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleTwitterCallback = (event) => {
      if (event.origin !== window.location.origin && event.origin !== baseUrl.replace(/\/$/, '')) {
        return;
      }

      if (event.data?.type === 'TWITTER_OK') {
        setStatusMessage('✅ Twitter connected successfully');
        setLoading(false);
        console.log('[Twitter] Connection successful');
        checkTwitterTokenStatus();
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (event.data?.type === 'TWITTER_ERR') {
        const msg = event.data.error || 'Twitter authorization failed';
        setStatusMessage(`❌ ${msg}`);
        setLoading(false);
        console.error('[Twitter] Connection error:', event.data);
        globalErrorHandler.logError(
          new Error(msg),
          { 
            component: 'Twitter OAuth',
            errorData: event.data
          }
        );
      }
    };

    window.addEventListener('message', handleTwitterCallback);
    return () => window.removeEventListener('message', handleTwitterCallback);
  }, [baseUrl]);

  const connectToTwitter = async () => {
    try {
      setLoading(true);
      setStatusMessage('Connecting to Twitter...');
      
      const tenantId = getTenantId();
      const authUrl = `${baseUrl}/api/integrations/twitter/connect/${tenantId}`;
      
      console.log('[Twitter OAuth 2.0] Opening popup for:', authUrl);
      
      const w = window.open(
        authUrl,
        'twitter_oauth',
        'width=600,height=700,menubar=no,toolbar=no,status=no'
      );
      if (!w) {
        setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
        setLoading(false);
        return;
      }
      w.focus?.();
    } catch (err) {
      console.error('❌ Failed to open Twitter popup:', err);
      setStatusMessage(`❌ ${err.message || 'Failed to connect to Twitter'}`);
      setLoading(false);
      globalErrorHandler.logError(err, { component: 'Twitter Connect' });
    }
  };

  const connectToTikTok = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/tiktok/login?tenantId=${encodeURIComponent(meTenant)}&direct=1`;
    const w = window.open(
      url,
      'tiktok_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'TK_OK' || ev.data.type === 'TIKTOK_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ TikTok connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'TK_ERR' || ev.data.type === 'TIKTOK_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_message || ev.data.error || 'TikTok login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('TIKTOK_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  async function peekEligibility(tenantId) {
    try {
      const peekRes = await fetch(`${baseUrl}/api/integrations/facebook/peek?tenantId=${tenantId}`);
      const peek = await peekRes.json();
      const pageCount = Array.isArray(peek?.pages) ? peek.pages.length : 0;

      setStatusMessage(
        pageCount > 0
          ? '✅ Facebook/Instagram connected'
          : 'Connected to Facebook. Ensure your IG is Business/Creator, linked to a Page, and you have Full control.'
      );
      
      fetchAttemptRef.current = 0;
      fetchConnectionStatus();
    } catch (e) {
      console.error('peek error', e);
      setStatusMessage('Connected, but could not verify eligibility. Check console.');
      globalErrorHandler.logError(e, { component: 'Facebook Peek' });
    }
  }

  const connectViaSdk = async () => {
    try {
      const FB = await ensureFbSdk(FB_APP_ID, FB_VERSION);

      if (!FB || typeof FB.login !== 'function') {
        throw new Error('Facebook SDK not ready');
      }

      setLoading(true);
      setStatusMessage('Opening Facebook login...');

      FB.login(
        (response) => {
          setLoading(false);

          if (!response?.authResponse) {
            setStatusMessage('❌ Login cancelled or failed');
            console.warn('FB login: no authResponse', response);
            return;
          }

          const { userID, accessToken } = response.authResponse;
          console.log('✅ FB login success. userID:', userID, 'accessToken:', accessToken);

          setStatusMessage('Connected to Facebook. Fetching eligible Pages...');

          FB.api(
            '/me/accounts',
            { fields: 'id,name,access_token,instagram_business_account' },
            async (apiResp) => {
              console.log('/me/accounts response:', apiResp);

              if (apiResp.error) {
                setStatusMessage(`❌ FB API error: ${apiResp.error.message}`);
                console.error('FB API error', apiResp.error);
                return;
              }

              const pages = (apiResp.data || [])
                .map((p) => ({
                  pageId: p.id,
                  pageName: p.name,
                  pageToken: p.access_token,
                  igUserId: p.instagram_business_account?.id || null,
                }))
                .filter((p) => p.pageToken);

              console.log('Extracted pages with IG:', pages);

              if (pages.length === 0) {
                setStatusMessage(
                  '❌ No eligible Pages found with full control. Check your FB permissions.'
                );
                return;
              }

              try {
                const tenantId = getTenantId();
                
                const saveResp = await fetch(`${baseUrl}/api/integrations/facebook/token-login`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ tenantId, accessToken }),
                });

                const saveData = await saveResp.json();
                if (saveData.success) {
                  await peekEligibility(tenantId);
                  
                  try {
                    console.log('[Instagram] Syncing username...');
                    const syncResponse = await fetch(
                      `${baseUrl}/api/integrations/instagram/sync-username/${tenantId}`,
                      { method: 'POST' }
                    );
                    const syncData = await syncResponse.json();
                    
                    if (syncData.success) {
                      console.log('✅ Instagram username synced:', syncData.username);
                    } else {
                      console.warn('⚠️ Instagram username sync failed:', syncData.message);
                    }
                  } catch (syncErr) {
                    console.error('Instagram username sync error:', syncErr);
                  }
                  
                  fetchAttemptRef.current = 0;
                  await fetchConnectionStatus();
                  
                } else {
                  setStatusMessage(`❌ Save failed: ${saveData.message}`);
                }
              } catch (err) {
                console.error('Save error', err);
                setStatusMessage('❌ Failed to save FB credentials');
                globalErrorHandler.logError(err, { component: 'Facebook Save' });
              }
            }
          );
        },
        {
          scope: 'pages_show_list,pages_read_engagement,pages_manage_posts,instagram_basic,instagram_content_publish',
          return_scopes: true,
        }
      );
    } catch (err) {
      setLoading(false);
      const msg = err?.message || 'Unknown error initializing Facebook SDK';
      setStatusMessage(`❌ ${msg}. Try the browser login instead.`);
      console.error('connectViaSdk error:', err);
      globalErrorHandler.logError(err, { component: 'Facebook Connect' });
    }
  };

  // Redirect-based Facebook OAuth — opens Facebook login in a popup window
  // using the server-side flow. This bypasses the JS SDK and reuses any
  // existing Facebook browser session, often avoiding 2FA entirely.
  const connectFacebookViaRedirect = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/facebook/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'fb_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );

    if (!w) {
      setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }

    w.focus?.();
    setLoading(true);
    setStatusMessage('Opening Facebook login...');

    const onMsg = (ev) => {
      if (!ev?.data) return;

      if (ev.data.type === 'FB_OK') {
        window.removeEventListener('message', onMsg);
        clearInterval(pollTimer);
        setLoading(false);
        setStatusMessage('✅ Facebook / Instagram connected');
        console.log('[Facebook] Redirect connection successful for tenant:', ev.data.tenantId);
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      }
    };

    window.addEventListener('message', onMsg);

    // Also poll for popup close in case postMessage doesn't fire
    const pollTimer = setInterval(() => {
      if (w && w.closed) {
        clearInterval(pollTimer);
        window.removeEventListener('message', onMsg);
        setLoading(false);
        // Check if connection was actually saved
        setTimeout(() => {
          fetchAttemptRef.current = 0;
          fetchConnectionStatus();
        }, 1000);
      }
    }, 500);
  };

  const connectLinkedIn = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/linkedin/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'li_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    
    if (!w) {
      setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      
      if (ev.data.type === 'LI_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ LinkedIn connected');
        console.log('[LinkedIn] Connection successful for tenant:', ev.data.tenantId);
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'LI_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_description || ev.data.error || 'LinkedIn login failed';
        setStatusMessage(`❌ LinkedIn: ${msg}`);
        console.error('[LinkedIn] Connection error:', ev.data);
      }
    };
    
    window.addEventListener('message', onMsg);
  };

  const connectYouTube = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/youtube/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'yt_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    
    if (!w) {
      setStatusMessage('❌ Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      
      if (ev.data.type === 'YT_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ YouTube connected');
        console.log('[YouTube] Connection successful for tenant:', ev.data.tenantId);
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'YT_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_description || ev.data.error || 'YouTube login failed';
        setStatusMessage(`❌ YouTube: ${msg}`);
        console.error('[YouTube] Connection error:', ev.data);
      }
    };
    
    window.addEventListener('message', onMsg);
  };

  const connectBluesky = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/bluesky/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'bsky_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'BSKY_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ Bluesky connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'BSKY_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error_message || ev.data.error || 'Bluesky login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('BSKY_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const connectThreads = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/threads/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'threads_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'THREADS_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ Threads connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'THREADS_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error || 'Threads login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('THREADS_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const connectPinterest = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/pinterest/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'pinterest_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'PINTEREST_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('✅ Pinterest connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'PINTEREST_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error || 'Pinterest login failed';
        setStatusMessage(`❌ ${msg}`);
        console.error('PINTEREST_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const connectTwitch = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/twitch/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'twitch_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'TWITCH_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('Twitch connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'TWITCH_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error || 'Twitch login failed';
        setStatusMessage(`Twitch error: ${msg}`);
        console.error('TWITCH_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const connectReddit = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/reddit/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'reddit_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'REDDIT_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('Reddit connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'REDDIT_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error || 'Reddit login failed';
        setStatusMessage(`Reddit error: ${msg}`);
        console.error('REDDIT_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  const connectEtsy = () => {
    const meTenant = getTenantId();
    const url = `${baseUrl}/api/integrations/etsy/login?tenantId=${encodeURIComponent(meTenant)}`;
    const w = window.open(
      url,
      'etsy_oauth',
      'width=700,height=800,menubar=no,toolbar=no,status=no'
    );
    if (!w) {
      setStatusMessage('Popup was blocked. Please allow popups for on-screen.app.');
      return;
    }
    w.focus?.();

    const onMsg = (ev) => {
      if (!ev?.data) return;
      if (ev.data.type === 'ETSY_OK') {
        window.removeEventListener('message', onMsg);
        setStatusMessage('Etsy connected');
        fetchAttemptRef.current = 0;
        fetchConnectionStatus();
      } else if (ev.data.type === 'ETSY_ERR') {
        window.removeEventListener('message', onMsg);
        const msg = ev.data.error || 'Etsy login failed';
        setStatusMessage(`Etsy error: ${msg}`);
        console.error('ETSY_ERR from popup:', ev.data);
      }
    };
    window.addEventListener('message', onMsg);
  };

  // Email SMTP integration handlers
  const fetchEmailConfig = async () => {
    try {
      const tenantId = getTenantId();
      const response = await fetch(`${baseUrl}/api/integrations/email/config/${tenantId}`);
      const data = await response.json();
      if (data.success && data.configured) {
        setEmailConfigured(true);
        setEmailPassMasked(data.config.pass_masked || '');
        setEmailConfig(prev => ({
          ...prev,
          host: data.config.host || '',
          port: String(data.config.port || '587'),
          user: data.config.user || '',
          from_address: data.config.from_address || '',
          secure: data.config.secure || false,
          pass: ''
        }));
      } else {
        setEmailConfigured(false);
      }
    } catch (err) {
      console.error('[Email Config] Fetch error:', err);
    }
  };

  const handleEmailTest = async () => {
    const { host, user, pass } = emailConfig;
    if (!host || !user || (!pass && !emailConfigured)) {
      setEmailMessage('Host, user, and password are required');
      return;
    }
    setEmailTesting(true);
    setEmailMessage('');
    try {
      const tenantId = getTenantId();
      const response = await fetch(`${baseUrl}/api/integrations/email/test`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...emailConfig, tenantId })
      });
      const data = await response.json();
      setEmailMessage(data.success ? `Verified! ${data.message}` : `Failed: ${data.error}`);
    } catch (err) {
      setEmailMessage(`Error: ${err.message}`);
    } finally {
      setEmailTesting(false);
    }
  };

  const handleEmailSave = async () => {
    const { host, user, pass } = emailConfig;
    if (!host || !user || (!pass && !emailConfigured)) {
      setEmailMessage('Host, user, and password are required');
      return;
    }
    setEmailSaving(true);
    setEmailMessage('');
    try {
      const tenantId = getTenantId();
      const payload = { ...emailConfig, tenantId };
      if (!payload.pass && emailConfigured) {
        setEmailMessage('Please re-enter your password to save');
        setEmailSaving(false);
        return;
      }
      const response = await fetch(`${baseUrl}/api/integrations/email/config`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (data.success) {
        setEmailMessage('Email configuration saved!');
        setEmailConfigured(true);
        setEmailConfig(prev => ({ ...prev, pass: '' }));
        await fetchEmailConfig();
      } else {
        setEmailMessage(`Save failed: ${data.error}`);
      }
    } catch (err) {
      setEmailMessage(`Error: ${err.message}`);
    } finally {
      setEmailSaving(false);
    }
  };

  const handleEmailDisconnect = async () => {
    if (!window.confirm('Remove your SMTP email configuration? Emails will be sent from the On-Screen account instead.')) return;
    try {
      const tenantId = getTenantId();
      const response = await fetch(`${baseUrl}/api/integrations/email/config/${tenantId}`, { method: 'DELETE' });
      const data = await response.json();
      if (data.success) {
        setEmailConfigured(false);
        setEmailConfig({ host: '', port: '587', user: '', pass: '', from_address: '', secure: false });
        setEmailPassMasked('');
        setEmailMessage('Email configuration removed');
        setShowEmailConfig(false);
      }
    } catch (err) {
      setEmailMessage(`Error: ${err.message}`);
    }
  };

  /**
   * UPDATED: Render integration button with improved layout
   * - Platform name centered at top
   * - Username centered below platform name in green (matching success message)
   * - All buttons same width with username truncation
   * - Delete button aligned to row, same height and width
   */
  const renderIntegrationButton = (provider, label, onClick) => {
    const status = connectionStatus[provider];
    const isConnected = status?.connected || false;
    const accountNameRaw = (status?.accountName || '').trim();
    const accountName = accountNameRaw
      ? (accountNameRaw.startsWith('@') ? accountNameRaw : `@${accountNameRaw}`)
      : '';

    return (
      <div className="integration-row">
        <button
          type="button"
          className="btn btn-primary integration-btn"
          onClick={onClick}
          disabled={loading}
        >
          <span className="integration-btn-content">
            {/* Platform label - centered at top */}
            <span className="integration-btn-label">{label.toUpperCase()}</span>

            {/* Username - centered below platform name in green */}
            {isConnected && accountName && (
              <span
                className="integration-btn-username"
                title={accountName}
              >
                {accountName}
              </span>
            )}
            
            {/* Checkmark - positioned absolutely in top right */}
            {isConnected && (
              <FaCheck className="integration-check" aria-label="Connected" />
            )}
          </span>
        </button>

        {/* Delete button - same height, aligned to row */}
        {isConnected ? (
          <button
            type="button"
            className="integration-delete-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDisconnect(provider);
            }}
            title={`Disconnect ${label}`}
            aria-label={`Disconnect ${label}`}
          >
            <FaTimes />
          </button>
        ) : (
          <span className="integration-delete-spacer" aria-hidden="true" />
        )}
      </div>
    );
  };

  return (
    <div className="owner-add-container">
      <div className="card">
        <h4 className="hdr hdr--primary hdr--lg">Integrations</h4>
        <div className="card-body">
          {loadingStatus && !statusError ? (
            <p>Loading connection status...</p>
          ) : statusError ? (
            <div style={{ padding: '20px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '5px', marginBottom: '20px' }}>
              <p style={{ margin: 0, color: '#856404' }}>
                ⚠️ {statusError}
              </p>
              <button 
                onClick={() => {
                  fetchAttemptRef.current = 0;
                  fetchConnectionStatus();
                }}
                style={{ marginTop: '10px', padding: '5px 15px', cursor: 'pointer' }}
              >
                Retry
              </button>
            </div>
          ) : (
            <form className="form integrations-form">

              {renderIntegrationButton('instagram', 'Instagram', connectViaSdk)}
              {renderIntegrationButton('facebook', 'Facebook', connectFacebookViaRedirect)}
              {renderIntegrationButton('twitter', 'Twitter', connectToTwitter)}
              {renderIntegrationButton('tiktok', 'TikTok', connectToTikTok)}

              {/* Twitter posting permissions warning */}
              {twitterTokenStatus?.connected && twitterTokenStatus?.needsPosting && (
                <div style={{ 
                  marginTop: '15px',
                  marginBottom: '15px',
                  padding: '15px', 
                  backgroundColor: '#fff3cd', 
                  border: '2px solid #ffc107',
                  borderRadius: '8px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                    <span style={{ fontSize: '24px' }}>⚠️</span>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ 
                        margin: '0 0 8px 0', 
                        color: '#856404',
                        fontSize: '16px',
                        fontWeight: '600'
                      }}>
                        Twitter Posting Permissions Required
                      </h4>
                      <p style={{ 
                        margin: '0 0 12px 0', 
                        fontSize: '14px', 
                        color: '#856404',
                        lineHeight: '1.5'
                      }}>
                        Your Twitter account is connected, but you need to grant additional permissions to enable post scheduling and media uploads.
                      </p>
                      <button
                        type="button"
                        onClick={grantTwitterPostingPermissions}
                        disabled={loading}
                        style={{
                          backgroundColor: '#ff6800',
                          color: 'white',
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: '600',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => {
                          if (!loading) {
                            e.target.style.backgroundColor = '#e55d00';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                          }
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = '#ff6800';
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                        }}
                      >
                        {loading ? 'Redirecting...' : 'Grant Posting Permissions'}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {renderIntegrationButton('linkedin', 'LinkedIn', connectLinkedIn)}
              {renderIntegrationButton('youtube', 'YouTube', connectYouTube)}
              {renderIntegrationButton('bluesky', 'Bluesky', connectBluesky)}
              {renderIntegrationButton('threads', 'Threads', connectThreads)}
              {renderIntegrationButton('pinterest', 'Pinterest', connectPinterest)}
              {renderIntegrationButton('etsy', 'Etsy', connectEtsy)}
              {/* {renderIntegrationButton('twitch', 'Twitch', connectTwitch)}

              {renderIntegrationButton('reddit', 'Reddit', connectReddit)} */}

              {/* Email SMTP Integration */}
              <div style={{ marginTop: '24px', borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
                <div className="integration-row">
                  <button
                    type="button"
                    className="btn btn-primary integration-btn"
                    onClick={() => setShowEmailConfig(!showEmailConfig)}
                    style={{ position: 'relative' }}
                  >
                    <span className="integration-btn-content">
                      <span className="integration-btn-label">
                        <FaEnvelope style={{ marginRight: '6px', verticalAlign: 'middle' }} />
                        EMAIL (SMTP)
                      </span>
                      {emailConfigured && (
                        <span className="integration-btn-username" title={emailConfig.user}>
                          {emailConfig.user}
                        </span>
                      )}
                      {emailConfigured && (
                        <FaCheck className="integration-check" aria-label="Configured" />
                      )}
                    </span>
                  </button>
                  {emailConfigured ? (
                    <button
                      type="button"
                      className="integration-delete-btn"
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEmailDisconnect(); }}
                      title="Remove email config"
                      aria-label="Remove email config"
                    >
                      <FaTimes />
                    </button>
                  ) : (
                    <span className="integration-delete-spacer" aria-hidden="true" />
                  )}
                </div>

                {showEmailConfig && (
                  <div style={{
                    marginTop: '12px',
                    padding: '16px',
                    backgroundColor: '#f9fafb',
                    border: '1px solid #e5e7eb',
                    borderRadius: '8px'
                  }}>
                    <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#6b7280' }}>
                      Send emails from your own account. If not configured, emails are sent from the On-Screen account.
                    </p>

                    {emailConfigured && (
                      <button
                        type="button"
                        onClick={handleEmailDisconnect}
                        style={{
                          width: '100%',
                          padding: '10px 16px',
                          marginBottom: '12px',
                          backgroundColor: '#253866',
                          color: '#ffffff',
                          border: 'none',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          fontSize: '14px',
                          fontWeight: '500'
                        }}
                      >
                        Revert to Default On-Screen Email
                      </button>
                    )}

                    {/* Quick presets */}
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
                      {[
                        { label: 'Gmail', host: 'smtp.gmail.com', port: '587', secure: false },
                        { label: 'Outlook', host: 'smtp.office365.com', port: '587', secure: false },
                        { label: 'Yahoo', host: 'smtp.mail.yahoo.com', port: '465', secure: true },
                        { label: 'IONOS', host: 'smtp.ionos.com', port: '587', secure: false },
                      ].map(preset => (
                        <button
                          key={preset.label}
                          type="button"
                          onClick={() => setEmailConfig(prev => ({ ...prev, host: preset.host, port: preset.port, secure: preset.secure }))}
                          style={{
                            padding: '4px 10px',
                            fontSize: '12px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            backgroundColor: emailConfig.host === preset.host ? '#111827' : '#fff',
                            color: emailConfig.host === preset.host ? '#fff' : '#374151',
                            cursor: 'pointer'
                          }}
                        >
                          {preset.label}
                        </button>
                      ))}
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '-6px' }}>Your Email Address</label>
                      <input
                        type="email"
                        placeholder="you@gmail.com"
                        value={emailConfig.user}
                        onChange={e => {
                          const val = e.target.value;
                          setEmailConfig(prev => {
                            const updated = { ...prev, user: val };
                            // Auto-detect host from email domain
                            if (!prev.host && val.includes('@')) {
                              const domain = val.split('@')[1]?.toLowerCase();
                              if (domain === 'gmail.com') { updated.host = 'smtp.gmail.com'; updated.port = '587'; }
                              else if (domain === 'outlook.com' || domain === 'hotmail.com') { updated.host = 'smtp.office365.com'; updated.port = '587'; }
                              else if (domain === 'yahoo.com') { updated.host = 'smtp.mail.yahoo.com'; updated.port = '465'; updated.secure = true; }
                            }
                            return updated;
                          });
                        }}
                        style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }}
                      />

                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '-6px' }}>App Password</label>
                      <PasswordInput
                        placeholder={emailConfigured ? `Current password (${emailPassMasked})` : 'Gmail: use App Password, not your login password'}
                        value={emailConfig.pass}
                        onChange={e => setEmailConfig(prev => ({ ...prev, pass: e.target.value }))}
                        style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }}
                      />

                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '-6px' }}>SMTP Server</label>
                      <input
                        type="text"
                        placeholder="smtp.gmail.com"
                        value={emailConfig.host}
                        onChange={e => setEmailConfig(prev => ({ ...prev, host: e.target.value }))}
                        style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }}
                      />
                      <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '-6px' }}>Port</label>
                      <input
                        type="number"
                        placeholder="587"
                        value={emailConfig.port}
                        onChange={e => setEmailConfig(prev => ({ ...prev, port: e.target.value }))}
                        style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', width: '100px' }}
                      />

                      <input
                        type="email"
                        placeholder="From Address (optional, defaults to your email)"
                        value={emailConfig.from_address}
                        onChange={e => setEmailConfig(prev => ({ ...prev, from_address: e.target.value }))}
                        style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px' }}
                      />

                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#374151' }}>
                        <input
                          type="checkbox"
                          checked={emailConfig.secure}
                          onChange={e => setEmailConfig(prev => ({ ...prev, secure: e.target.checked }))}
                        />
                        Use SSL/TLS (port 465)
                      </label>

                      {emailMessage && (
                        <p style={{
                          margin: 0,
                          padding: '8px 12px',
                          borderRadius: '6px',
                          fontSize: '13px',
                          backgroundColor: emailMessage.startsWith('Verified') || emailMessage.includes('saved') ? '#d1fae5' : emailMessage.startsWith('Failed') || emailMessage.startsWith('Error') ? '#fee2e2' : '#fef3c7',
                          color: emailMessage.startsWith('Verified') || emailMessage.includes('saved') ? '#065f46' : emailMessage.startsWith('Failed') || emailMessage.startsWith('Error') ? '#991b1b' : '#92400e'
                        }}>
                          {emailMessage}
                        </p>
                      )}

                      <div style={{ display: 'flex', gap: '10px', marginTop: '4px' }}>
                        <button
                          type="button"
                          onClick={handleEmailTest}
                          disabled={emailTesting}
                          style={{
                            flex: 1,
                            padding: '10px 16px',
                            backgroundColor: '#f3f4f6',
                            color: '#374151',
                            border: '1px solid #d1d5db',
                            borderRadius: '6px',
                            cursor: emailTesting ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                          }}
                        >
                          {emailTesting ? 'Testing...' : 'Test Connection'}
                        </button>
                        <button
                          type="button"
                          onClick={handleEmailSave}
                          disabled={emailSaving}
                          style={{
                            flex: 1,
                            padding: '10px 16px',
                            backgroundColor: '#111827',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: emailSaving ? 'not-allowed' : 'pointer',
                            fontSize: '14px',
                            fontWeight: '500'
                          }}
                        >
                          {emailSaving ? 'Saving...' : 'Save Configuration'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Status message with matching style */}
              {statusMessage && (
                <p className="integrations-status-message">{statusMessage}</p>
              )}
            </form>
          )}
        </div>
      </div>

      {showTikTokMetrics && (
        <div className="mt-4">
          <TikTokMetrics tenantId={getTenantId()} />
        </div>
      )}

      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: "Back",
            onClick: () => navigate(-1),
          },
          { icon: <FaHome />, label: 'Home', onClick: handleDashboard }
        ]}
      />
    </div>
  );
}

export default Integrations;